import React from 'react';
import BottomNav from '../components/BottomNav';

const SupercarClub = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Supercar Club</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Drive the World's Finest Automobiles</p>
        
        <div className="card">
          <p>
            Experience the thrill of driving luxury and performance vehicles. Access an exclusive 
            fleet of supercars and exotic automobiles on demand.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Exotic Fleet</h3>
              <p>Ferrari, Lamborghini, McLaren, and more</p>
            </div>
            <div className="feature-item">
              <h3>Track Days</h3>
              <p>Professional instruction and circuit experiences</p>
            </div>
            <div className="feature-item">
              <h3>Events & Tours</h3>
              <p>Exclusive driving experiences and rallies</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default SupercarClub;
